import axiosInstance from "@/api/axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toastService from "@/services/toastService";

const initialState = {
  admin: null,
  loading: false,
  error: null,
  country: null,
  loginDialog: false,
};
// Async thunk for admin login
export const signInAdmin = createAsyncThunk(
  "admin/login",
  async (credentials: { email: string; password: string }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance({
        method: "POST",
        url: "/user/api/v1/admin/login",
        data: credentials,
      });
      toastService.success("Admin logged in successfully");
      return response.data.data;
    } catch (error: any) {
      // toastService.error("Admin login failed");
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

// Async thunk for logout
export const logoutAdmin = createAsyncThunk("admin/logout", async () => {
  const response = await axiosInstance({
    method: "POST",
    url: "/user/api/v1/admin/adminLogout",
  });
  // toastService.success("Admin logged out");
  return response.data.data;
});

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setAdmin: (state, action) => {
      state.admin = action.payload;
      if (action.payload && action.payload?.accessToken) {
        localStorage.setItem("admin", JSON.stringify(action.payload));
        localStorage.setItem("adminAccessToken", action.payload.accessToken);
      }
    },
    changeCountry: (state, action) => {
      state.country = action.payload;
    },
    toggleloginDialog: (state, action) => {
      if (!state.admin) {
        state.loginDialog = action.payload;
      }
    },
    // renamed to avoid conflict
    logoutAdminReducer: (state) => {
      state.admin = null;
      localStorage.removeItem("adminAccessToken");
      localStorage.removeItem("admin");
      // toastService.success("Admin logged out");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInAdmin.fulfilled, (state, action) => {
        state.loading = false;
        state.admin = action.payload;
        localStorage.setItem("admin", JSON.stringify(action.payload));
        localStorage.setItem("adminAccessToken", action.payload.accessToken);
      })
      .addCase(signInAdmin.rejected, (state, action) => {
        console.error(action.payload,"line 75");
        state.loading = false;
        // state.error = action.payload || "Something went wrong";
      })
      .addCase(logoutAdmin.fulfilled, () => {
        // localStorage.clear();
        localStorage.removeItem("admin");
        localStorage.removeItem("adminAccessToken");
        toastService.success("Admin logged out");
        return initialState;
      })
      .addCase(logoutAdmin.rejected, () => {
        // localStorage.clear();
        localStorage.removeItem("admin");
        localStorage.removeItem("adminAccessToken");
        return initialState;
      });
  },
});

export const {
  setAdmin,
  changeCountry,
  toggleloginDialog,
  logoutAdminReducer, // renamed version
} = adminSlice.actions;

export default adminSlice.reducer;
